// extracted by mini-css-extract-plugin
export default {"inner":"LandingSeriesGridItem_inner__DQVJm"};